{
  "HELP_CENTER": {
    "TITLE": "Pomoč",
    "NEW_PAGE": {
      "DESCRIPTION": "Ustvarite portale samopostrežnega centra za pomoč za vaše stranke. Pomagajte jim hitro najti odgovore, brez čakanja. Poenostavite povpraševanja, povečajte učinkovitost agentov in izboljšajte podporo strankam.",
      "CREATE_PORTAL_BUTTON": "Ustvari portal"
    },
    "HEADER": {
      "FILTER": "Filtriraj po",
      "SORT": "Razvrsti po",
      "LOCALE": "Jezik",
      "SETTINGS_BUTTON": "Nastavitve",
      "NEW_BUTTON": "Nov članek",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Objavljeno",
        "DRAFT": "Osnutek",
        "ARCHIVED": "Arhivirano"
      },
      "TITLES": {
        "ALL_ARTICLES": "Vsi članki",
        "MINE": "Moji članki",
        "DRAFT": "Osnutki člankov",
        "ARCHIVED": "Arhivirani članki"
      },
      "LOCALE_SELECT": {
        "TITLE": "Izberite jezik",
        "PLACEHOLDER": "Izberite jezik",
        "NO_RESULT": "Jezik ni najden",
        "SEARCH_PLACEHOLDER": "Išči jezik"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Vsi članki",
      "PUBLISH_BUTTON": "Objavi",
      "MOVE_TO_ARCHIVE_BUTTON": "Premakni v arhiv",
      "PREVIEW": "Predogled",
      "ADD_TRANSLATION": "Dodaj prevod",
      "OPEN_SIDEBAR": "Odpri stransko vrstico",
      "CLOSE_SIDEBAR": "Zapri stransko vrstico",
      "SAVING": "Shranjujem...",
      "SAVED": "Shranjeno"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Naloži sliko",
        "UPLOADING": "Nalaganje...",
        "SUCCESS": "Slika je bila uspešno naložena",
        "ERROR": "Napaka med nalaganjem slike",
        "UN_AUTHORIZED_ERROR": "Nimate dovoljenja za nalaganje slik",
        "ERROR_FILE_SIZE": "Velikost slike mora biti manjša od {size}MB",
        "ERROR_FILE_FORMAT": "Datoteka mora biti v podprtem slikovnem formatu",
        "ERROR_FILE_DIMENSIONS": "Dimenzije slike morajo biti manjše od 2000 krat 2000 slikovnih pik"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Nastavitve članka",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategorija",
          "TITLE": "Izberite kategorijo",
          "PLACEHOLDER": "Izberite kategorijo",
          "NO_RESULT": "Kategorija ni najdena",
          "SEARCH_PLACEHOLDER": "Išči kategorijo"
        },
        "AUTHOR": {
          "LABEL": "Avtor",
          "TITLE": "Izberi avtorja",
          "PLACEHOLDER": "Izberi avtorja",
          "NO_RESULT": "Ni najdenih avtorjev",
          "SEARCH_PLACEHOLDER": "Išči avtorja"
        },
        "META_TITLE": {
          "LABEL": "Meta naslov",
          "PLACEHOLDER": "Dodaj meta naslov"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta opis",
          "PLACEHOLDER": "Dodaj meta opis za boljše SEO rezultate..."
        },
        "META_TAGS": {
          "LABEL": "Meta oznake",
          "PLACEHOLDER": "Dodajte meta oznake, ločene z vejico..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arhiviraj članek",
        "DELETE": "Izbriši članek"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Brez kategorije",
      "SEARCH_RESULTS": "Rezultati iskanja za {query}",
      "EMPTY_TEXT": "Išči članke za vstavljanje v odgovore.",
      "SEARCH_LOADER": "Iskanje ...",
      "INSERT_ARTICLE": "Vstavi",
      "NO_RESULT": "Ni najdenih člankov",
      "COPY_LINK": "Kopiraj povezavo do članka v odložišče",
      "OPEN_LINK": "Odpri članek v novem zavihku",
      "PREVIEW_LINK": "Predogled članka"
    },
    "PORTAL": {
      "HEADER": "Portali",
      "DEFAULT": "Privzeto",
      "NEW_BUTTON": "Nov portal",
      "ACTIVE_BADGE": "aktivno",
      "CHOOSE_LOCALE_LABEL": "Izberite jezikovno različico",
      "LOADING_MESSAGE": "Nalaganje portalov...",
      "ARTICLES_LABEL": "članki",
      "NO_PORTALS_MESSAGE": "Ni razpoložljivih portalov",
      "ADD_NEW_LOCALE": "Dodaj novo jezikovno različico",
      "POPOVER": {
        "TITLE": "Portali",
        "PORTAL_SETTINGS": "Nastavitve portala",
        "SUBTITLE": "Imate več portalov in za vsak portal lahko nastavite različne jezikovne različice.",
        "CANCEL_BUTTON_LABEL": "Prekliči",
        "CHOOSE_LOCALE_BUTTON": "Izberi jezik"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "članki",
            "ADD": "Dodaj jezik",
            "VISIT": "Obišči stran",
            "SETTINGS": "Nastavitve",
            "DELETE": "Izbriši"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Konfiguracije portala",
            "ITEMS": {
              "NAME": "Ime",
              "DOMAIN": "Lastna domena",
              "SLUG": "Oznaka",
              "TITLE": "Naslov portala",
              "THEME": "Barva teme",
              "SUB_TEXT": "Podnaslov portala"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Razpoložljivi jeziki",
            "TABLE": {
              "NAME": "Ime jezika",
              "CODE": "Koda jezika",
              "ARTICLE_COUNT": "Št. člankov",
              "CATEGORIES": "Št. kategorij",
              "SWAP": "Zamenjaj",
              "DELETE": "Izbriši",
              "DEFAULT_LOCALE": "Privzeto"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Izbriši portal",
          "MESSAGE": "Ali ste prepričani, da želite izbrisati ta portal",
          "YES": "Da, izbriši portal",
          "NO": "Ne, obdrži portal",
          "API": {
            "DELETE_SUCCESS": "Portal je bil uspešno izbrisan",
            "DELETE_ERROR": "Napaka pri brisanju portala"
          }
        },
        "SEND_CNAME_INSTRUCTIONS": {
          "API": {
            "SUCCESS_MESSAGE": "Navodila za CNAME so bila uspešno poslana",
            "ERROR_MESSAGE": "Napaka pri pošiljanju navodil za CNAME"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Uredi portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Osnovne informacije"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Prilagoditev portala"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorije"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Jeziki"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorije v",
          "NEW_CATEGORY": "Nova kategorija",
          "TABLE": {
            "NAME": "Ime",
            "DESCRIPTION": "Opis",
            "LOCALE": "Lokalizacija",
            "ARTICLE_COUNT": "Št. člankov",
            "ACTION_BUTTON": {
              "EDIT": "Uredi kategorijo",
              "DELETE": "Izbriši kategorijo"
            },
            "EMPTY_TEXT": "Ni najdenih kategorij"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Posodobi osnovne nastavitve"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informacije centra za pomoč",
            "BODY": "Osnovne informacije o portalu"
          },
          "CUSTOMIZATION": {
            "TITLE": "Prilagoditev centra za pomoč",
            "BODY": "Prilagodite portal"
          },
          "FINISH": {
            "TITLE": "Odlično! 🎉",
            "BODY": "Vse je pripravljeno!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Nazaj",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Ustvari portal",
            "TITLE": "Informacije o centru za pomoč",
            "CREATE_BASIC_SETTING_BUTTON": "Ustvari osnovne nastavitve portala"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Prilagoditev portala",
            "TITLE": "Prilagoditev centra za pomoč",
            "UPDATE_PORTAL_BUTTON": "Posodobi nastavitve portala"
          },
          "FINISH_PAGE": {
            "TITLE": "Odlično!🎉 Vse je pripravljeno!",
            "MESSAGE": "Zdaj lahko ta ustvarjeni portal vidite na strani vseh portalov.",
            "FINISH": "Pojdi na stran vseh portalov"
          }
        },
        "LOGO": {
          "LABEL": "Logotip",
          "UPLOAD_BUTTON": "Naloži logotip",
          "HELP_TEXT": "Ta logotip bo prikazan v glavi portala.",
          "IMAGE_UPLOAD_SUCCESS": "Logotip je bil uspešno naložen",
          "IMAGE_UPLOAD_ERROR": "Logotip je bil uspešno izbrisan",
          "IMAGE_DELETE_ERROR": "Napaka pri brisanju logotipa"
        },
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Ime portala",
          "HELP_TEXT": "Ime bo uporabljeno v javnem portalu interno.",
          "ERROR": "Ime je obvezno"
        },
        "SLUG": {
          "LABEL": "Oznaka",
          "PLACEHOLDER": "Oznaka portala za spletne naslove",
          "ERROR": "Slug je obvezen"
        },
        "DOMAIN": {
          "LABEL": "Lastna domena",
          "PLACEHOLDER": "Lastna domena portala",
          "HELP_TEXT": "Dodajte samo, če želite za svoje portale uporabljati lastno domeno. Na primer: {exampleURL}",
          "ERROR": "Vnesite veljaven URL domene"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Povezava na domačo stran",
          "PLACEHOLDER": "Povezava do domače strani portala",
          "HELP_TEXT": "Povezava za vrnitev s portala na domačo stran. Na primer: {exampleURL}",
          "ERROR": "Vnesite veljaven URL domače strani"
        },
        "THEME_COLOR": {
          "LABEL": "Barva teme portala",
          "HELP_TEXT": "Ta barva bo prikazana kot barva teme za portal."
        },
        "PAGE_TITLE": {
          "LABEL": "Naslov strani",
          "PLACEHOLDER": "Naslov portala",
          "HELP_TEXT": "Naslov strani bo uporabljen v javnem portalu.",
          "ERROR": "Naslov strani je obvezen"
        },
        "HEADER_TEXT": {
          "LABEL": "Besedilo glave",
          "PLACEHOLDER": "Besedilo glave portala",
          "HELP_TEXT": "Besedilo glave portala bo prikazano v javnem portalu.",
          "ERROR": "Besedilo glave portala je obvezno"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal je bil uspešno ustvarjen.",
          "ERROR_MESSAGE_FOR_BASIC": "Portal ni bilo mogoče ustvariti. Poskusite znova.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal je bil uspešno posodobljen.",
          "ERROR_MESSAGE_FOR_UPDATE": "Portal ni bilo mogoče posodobiti. Poskusite znova."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Dodaj nov jezik",
        "SUB_TITLE": "S tem dodate nov jezik na seznam razpoložljivih prevodov.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Jezik",
          "PLACEHOLDER": "Izberite jezik",
          "ERROR": "Izbira jezika je obvezna"
        },
        "BUTTONS": {
          "CREATE": "Ustvari jezik",
          "CANCEL": "Prekliči"
        },
        "API": {
          "SUCCESS_MESSAGE": "Jezik je bil uspešno dodan",
          "ERROR_MESSAGE": "Dodajanje jezika ni uspelo. Poskusi znova."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Privzeti jezik je bil uspešno posodobljen",
          "ERROR_MESSAGE": "Posodobitev privzetega jezika ni uspela. Poskusite znova."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Jezik je bil uspešno odstranjen iz portala",
          "ERROR_MESSAGE": "Jezika ni bilo mogoče odstraniti iz portala. Poskusite znova."
        }
      },
      "DRAFT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale moved to draft successfully",
          "ERROR_MESSAGE": "Unable to move locale to draft. Try again."
        }
      },
      "PUBLISH_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale published successfully",
          "ERROR_MESSAGE": "Unable to publish locale. Try again."
        }
      }
    },
    "TABLE": {
      "LOADING_MESSAGE": "Nalaganje člankov...",
      "404": "Noben članek ne ustreza vašemu iskanju 🔍",
      "NO_ARTICLES": "Ni razpoložljivih člankov",
      "HEADERS": {
        "TITLE": "Naslov",
        "CATEGORY": "Kategorija",
        "READ_COUNT": "Ogledi",
        "STATUS": "Stanje",
        "LAST_EDITED": "Zadnja sprememba"
      },
      "COLUMNS": {
        "BY": "avtor",
        "AUTHOR_NOT_AVAILABLE": "Avtor ni na voljo"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Nalaganje članka...",
      "TITLE_PLACEHOLDER": "Naslov članka tukaj",
      "CONTENT_PLACEHOLDER": "Napišite svoj članek tukaj",
      "API": {
        "ERROR": "Napaka pri shranjevanju članka"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Napaka med objavo članka",
        "SUCCESS": "Članek je bil uspešno objavljen"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Napaka pri arhiviranju članka",
        "SUCCESS": "Članek je bil uspešno arhiviran"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Napaka pri ustvarjanju osnutka članka",
        "SUCCESS": "Članek je bil uspešno shranjen kot osnutek"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Potrdite brisanje",
          "MESSAGE": "Ste prepričani, da želite izbrisati članek?",
          "YES": "Da, izbriši",
          "NO": "Ne, obdrži"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Članek je bil uspešno izbrisan",
        "ERROR_MESSAGE": "Napaka pri brisanju članka"
      }
    },
    "REORDER_ARTICLE": {
      "API": {
        "ERROR_MESSAGE": "Ni mogoče spremeniti vrstnega reda člankov. Poskusite znova."
      }
    },
    "REORDER_CATEGORY": {
      "API": {
        "ERROR_MESSAGE": "Ni mogoče spremeniti vrstnega reda kategorij. Poskusite znova."
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Prosimo, dodajte naslov in vsebino članka, šele nato lahko posodobite nastavitve"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Išči članke"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Ustvari kategorijo",
        "SUB_TITLE": "Kategorija bo uporabljena v javnem portalu za razvrščanje člankov.",
        "PORTAL": "Portal",
        "LOCALE": "Jezik",
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Ime kategorije",
          "HELP_TEXT": "Ime kategorije in ikona bosta uporabljena v javnem portalu za kategorizacijo člankov.",
          "ERROR": "Ime je obvezno"
        },
        "SLUG": {
          "LABEL": "Oznaka",
          "PLACEHOLDER": "Oznaka kategorije za spletne naslove",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/sl-SI/categories/my-slug",
          "ERROR": "Slug je obvezen"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Navedite kratek opis kategorije.",
          "ERROR": "Opis je obvezen"
        },
        "BUTTONS": {
          "CREATE": "Ustvari kategorijo",
          "CANCEL": "Prekliči"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je bila uspešno ustvarjena",
          "ERROR_MESSAGE": "Ni mogoče ustvariti kategorije"
        }
      },
      "EDIT": {
        "TITLE": "Uredi kategorijo",
        "SUB_TITLE": "Urejanje kategorije bo posodobilo kategorijo v javnem portalu.",
        "PORTAL": "Portal",
        "LOCALE": "Lokalno",
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Ime kategorije",
          "HELP_TEXT": "Ime kategorije in ikona bosta uporabljena v javnem portalu za kategorizacijo člankov.",
          "ERROR": "Ime je obvezno"
        },
        "SLUG": {
          "LABEL": "Oznaka",
          "PLACEHOLDER": "Oznaka kategorije za spletne naslove",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/sl-SI/categories/my-slug",
          "ERROR": "Slug je obvezen"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Navedite kratek opis kategorije.",
          "ERROR": "Opis je obvezen"
        },
        "BUTTONS": {
          "CREATE": "Posodobi kategorijo",
          "CANCEL": "Prekliči"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je bila uspešno posodobljena",
          "ERROR_MESSAGE": "Posodobitev kategorije ni uspela"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je bila uspešno izbrisana",
          "ERROR_MESSAGE": "Brisanje kategorije ni bilo mogoče"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Išči članke",
      "PLACEHOLDER": "Išči članke",
      "NO_RESULT": "Ni najdenih člankov",
      "SEARCHING": "Iskanje ...",
      "SEARCH_BUTTON": "Išči",
      "INSERT_ARTICLE": "Vstavi povezavo",
      "IFRAME_ERROR": "URL je prazen ali neveljaven. Vsebina ni prikazana.",
      "OPEN_ARTICLE_SEARCH": "Vstavi članek iz Pomoč centra",
      "SUCCESS_ARTICLE_INSERTED": "Članek je bil uspešno vstavljen",
      "PREVIEW_LINK": "Predogled članka",
      "CANCEL": "Zapri",
      "BACK": "Nazaj",
      "BACK_RESULTS": "Nazaj na rezultate"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Pomoč",
      "DESCRIPTION": "Ustvarite uporabniku prijazne portale za samopostrežno pomoč. Pomagajte svojim uporabnikom pri dostopu do člankov in zagotovite 24-urno podporo v 7-dnevnem tednu. Nadgradite naročnino, da omogočite to funkcijo.",
      "SELF_HOSTED_DESCRIPTION": "Ustvarite uporabniku prijazne portale za samopostrežno pomoč. Pomagajte svojim uporabnikom pri dostopu do člankov in zagotovite 24-urno podporo v 7-dnevnem tednu. Za omogočitev te funkcije se obrnite na skrbnika.",
      "BUTTON": {
        "LEARN_MORE": "Izvedi več",
        "UPGRADE": "Nadgradi"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Več portalov",
          "DESCRIPTION": "Ustvarite več portalov centra za pomoč za različne izdelke z uporabo istega računa."
        },
        "LOCALES": {
          "TITLE": "Popolna podpora za jezikovne različice",
          "DESCRIPTION": "Lokalizirajte portal v svojem jeziku. Podpiramo vse jezikovne različice in omogočamo prevode za vsak članek."
        },
        "SEO": {
          "TITLE": "Oblikovanje prijazno za SEO",
          "DESCRIPTION": "Prilagodite meta oznake in izboljšajte vidnost v iskalnikih z našimi stranmi, optimiziranimi za SEO."
        },
        "API": {
          "TITLE": "Popolna podpora za API",
          "DESCRIPTION": "Portal uporabite kot sistem za upravljanje vsebine brez uporabniškega vmesnika z zunanjimi ogrodji uporabniškega vmesnika prek naših programskih vmesnikov."
        }
      }
    },
    "LOADING": "Nalaganje...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} ogled | {count} ogledi",
          "DROPDOWN_MENU": {
            "PUBLISH": "Objavi",
            "DRAFT": "Osnutek",
            "ARCHIVE": "Arhiviraj",
            "TRANSLATE": "Translate",
            "DELETE": "Izbriši"
          },
          "STATUS": {
            "DRAFT": "Osnutek",
            "PUBLISHED": "Objavljeno",
            "ARCHIVED": "Arhivirano"
          },
          "PENDING_EDITS": "Unpublished edits",
          "PENDING_EDITS_TOOLTIP": "This published article has unpublished edits",
          "CATEGORY": {
            "UNCATEGORISED": "Brez kategorije"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Vsi članki",
          "MINE": "Moji",
          "DRAFT": "Osnutek",
          "PUBLISHED": "Objavljeno",
          "ARCHIVED": "Arhivirano"
        },
        "CATEGORY": {
          "ALL": "Vse kategorije"
        },
        "LOCALE": {
          "ALL": "Vsi jeziki"
        },
        "SEARCH_PLACEHOLDER": "Išči članke...",
        "NEW_ARTICLE": "Nov članek"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Napišite članek",
          "SUBTITLE": "Napišite bogat članek, začnimo!",
          "BUTTON_LABEL": "Nov članek"
        },
        "MINE": {
          "TITLE": "Tukaj še niste napisali nobenega članka",
          "SUBTITLE": "Vsi članki, ki ste jih napisali, so tukaj za hiter dostop."
        },
        "DRAFT": {
          "TITLE": "Ni nobenih člankov v osnutkih",
          "SUBTITLE": "Osnutki člankov se bodo prikazali tukaj"
        },
        "PUBLISHED": {
          "TITLE": "Ni nobenih objavljenih člankov",
          "SUBTITLE": "Objavljeni članki se bodo prikazali tukaj"
        },
        "ARCHIVED": {
          "TITLE": "Ni nobenih člankov v arhivu",
          "SUBTITLE": "Arhivirani članki se ne prikazujejo na portalu, lahko jih uporabite za označevanje zastarelih ali neveljavnih strani"
        },
        "CATEGORY": {
          "TITLE": "V tej kategoriji ni člankov",
          "SUBTITLE": "Članki v tej kategoriji se bodo prikazali tukaj"
        },
        "SEARCH": {
          "TITLE": "No matching articles",
          "SUBTITLE": "We couldn't find any articles matching your search. Try a different term."
        }
      },
      "BULK_TRANSLATE": {
        "TITLE": "Translate article | Translate {count} articles",
        "DESCRIPTION": "Translate the selected article to another language. | Translate the selected articles to another language.",
        "LOCALE_LABEL": "Target language",
        "LOCALE_PLACEHOLDER": "Select a language",
        "CATEGORY_LABEL": "Target category",
        "CATEGORY_PLACEHOLDER": "Select a category",
        "OPTIONAL": "(optional)",
        "CONFIRM": "Translate",
        "SELECT_ALL": "Select all ({count})",
        "SELECTED_COUNT": "{count} izbranih",
        "CLEAR_SELECTION": "Počisti izbiro",
        "TRANSLATE_BUTTON": "Translate",
        "CONFIRM_OVERWRITE": "Overwrite and translate",
        "DUPLICATE_WARNING": "A translation already exists for this article in the selected language. | Translations already exist for {count} articles in the selected language.",
        "DUPLICATE_CONFIRM_HINT": "Click translate again to overwrite the existing translation.",
        "API": {
          "SUCCESS_MESSAGE": "Translation in progress. The article will appear as a draft once ready.",
          "ERROR_MESSAGE": "Failed to start translation. Please try again."
        }
      },
      "BULK_ACTIONS": {
        "PUBLISH": "Objavi",
        "DRAFT": "Osnutek",
        "ARCHIVE": "Arhiviraj",
        "TRANSLATE": "Translate",
        "MOVE_TO_CATEGORY": "Kategorija",
        "DELETE": "Delete",
        "STATUS_SUCCESS": "Articles updated successfully",
        "STATUS_ERROR": "Failed to update articles",
        "STATUS_SKIPPED": "1 article with unpublished edits was skipped — open it to publish or discard. | {count} articles with unpublished edits were skipped — open them to publish or discard.",
        "STATUS_SKIPPED_ALL": "These articles have unpublished edits — open each to publish or discard.",
        "CATEGORY_SUCCESS": "Articles moved successfully",
        "CATEGORY_ERROR": "Failed to move articles",
        "DELETE_CONFIRM_TITLE": "Delete article | Delete {count} articles",
        "DELETE_CONFIRM_DESCRIPTION": "This will permanently delete the selected article. This action cannot be undone. | This will permanently delete {count} selected articles. This action cannot be undone.",
        "DELETE_CONFIRM": "Delete",
        "DELETE_SUCCESS": "Articles deleted successfully",
        "DELETE_ERROR": "Failed to delete articles"
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nova kategorija",
        "EDIT_CATEGORY": "Uredi kategorijo",
        "SEARCH_PLACEHOLDER": "Search categories...",
        "CATEGORIES_COUNT": "{n} kategorija | {n} kategorije",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategorije ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} člankov) | {categoryName} ({categoryCount} članek)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Ni najdenih kategorij",
        "SUBTITLE": "Kategorije se bodo prikazale tukaj. Kategorijo lahko dodate s klikom na gumb »Nova kategorija«."
      },
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching categories",
        "SUBTITLE": "We couldn't find any categories matching your search. Try a different term."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} članek | {count} članki"
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je bila uspešno ustvarjena",
            "ERROR_MESSAGE": "Ni bilo mogoče ustvariti kategorije"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je bila uspešno posodobljena",
            "ERROR_MESSAGE": "Posodobitev kategorije ni bila mogoča"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je bila uspešno izbrisana",
            "ERROR_MESSAGE": "Brisanje kategorije ni bilo mogoče"
          }
        },
        "HEADER": {
          "CREATE": "Ustvari kategorijo",
          "EDIT": "Uredi kategorijo",
          "DESCRIPTION": "Urejanje kategorije bo posodobilo kategorijo v javnem portalu.",
          "PORTAL": "Portal",
          "LOCALE": "Jezik"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Ime",
            "PLACEHOLDER": "Ime kategorije",
            "ERROR": "Ime je obvezno"
          },
          "SLUG": {
            "LABEL": "Oznaka",
            "PLACEHOLDER": "Oznaka kategorije za spletne naslove",
            "ERROR": "Slug je obvezen",
            "HELP_TEXT": "app.chatwoot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Opis",
            "PLACEHOLDER": "Navedite kratek opis kategorije.",
            "ERROR": "Opis je obvezen"
          }
        },
        "BUTTONS": {
          "CREATE": "Ustvari",
          "EDIT": "Posodobi",
          "CANCEL": "Prekliči"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Ni razpoložljivih jezikovnih različic | {n} jezikovna različica | {n} jezikovnih različic",
      "NEW_LOCALE_BUTTON_TEXT": "Nov jezik",
      "SEARCH_PLACEHOLDER": "Search locales...",
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching locales",
        "SUBTITLE": "We couldn't find any locales matching your search. Try a different term."
      },
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} članek | {count} članki",
        "CATEGORIES_COUNT": "{count} kategorija | {count} kategorije",
        "DEFAULT": "Privzeto",
        "DRAFT": "Osnutek",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Nastavi kot privzeto",
          "MOVE_TO_DRAFT": "Move to draft",
          "PUBLISH_LOCALE": "Publish locale",
          "CUSTOMIZE_CONTENT": "Localize content",
          "SELECT_POPULAR_CONTENT": "Select recommended content",
          "DELETE": "Izbriši"
        }
      },
      "POPULAR_CONTENT_DIALOG": {
        "TITLE": "Recommended content",
        "DESCRIPTION": "Pick up to 3 categories and 6 articles to feature on this locale's help center home page. Drag them into the order you want visitors to see.",
        "SEARCH": "Iskanje ...",
        "EMPTY": "No matching results",
        "ADD_ANOTHER": "Add another...",
        "SLOTS_LEFT": "{count} slots left",
        "OVERRIDING_DEFAULTS": "Overriding defaults for this locale",
        "CONFIRM": "Save recommendations",
        "CATEGORIES": {
          "LABEL": "Recommended categories",
          "ARTICLES_COUNT": "No articles | {count} article | {count} articles"
        },
        "ARTICLES": {
          "LABEL": "Recommended articles",
          "IN_CATEGORY": "in {category}",
          "UNCATEGORIZED": "Brez kategorije"
        },
        "API": {
          "SUCCESS_MESSAGE": "Recommended content updated successfully",
          "ERROR_MESSAGE": "Unable to update recommended content. Try again."
        }
      },
      "CONTENT_DIALOG": {
        "TITLE": "Localize content",
        "DESCRIPTION": "Set values specific to this locale. Anything left blank falls back to the default locale.",
        "NAME": {
          "LABEL": "Name"
        },
        "PAGE_TITLE": {
          "LABEL": "Naslov strani"
        },
        "HEADER_TEXT": {
          "LABEL": "Besedilo glave"
        },
        "API": {
          "SUCCESS_MESSAGE": "Locale content updated successfully",
          "ERROR_MESSAGE": "Unable to update locale content. Try again."
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Dodaj nov jezik",
        "DESCRIPTION": "Izberite jezik, v katerem bo ta članek napisan. Ta bo dodan na vaš seznam prevodov, kasneje pa lahko dodate še več.",
        "COMBOBOX": {
          "PLACEHOLDER": "Izberite jezik..."
        },
        "STATUS": {
          "LABEL": "Status",
          "OPTIONS": {
            "LIVE": "Objavljeno",
            "DRAFT": "Osnutek"
          }
        },
        "API": {
          "SUCCESS_MESSAGE": "Jezik je bil uspešno dodan",
          "ERROR_MESSAGE": "Dodajanje jezika ni uspelo. Poskusite znova."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Shranjujem...",
          "SAVED": "Shranjeno"
        },
        "PREVIEW": "Predogled",
        "PUBLISH": "Objavi",
        "PUBLISH_CHANGES": "Publish changes",
        "PUBLISH_CHANGES_SUCCESS": "Changes published successfully",
        "PUBLISH_CHANGES_ERROR": "Could not publish changes",
        "SAVE_IN_PROGRESS": "Still saving your latest changes — please try again in a moment.",
        "DISCARD_CHANGES": "Discard changes",
        "DISCARD_CHANGES_SUCCESS": "Changes discarded",
        "DISCARD_CHANGES_ERROR": "Could not discard changes",
        "PENDING_CHANGES": "Pending changes",
        "VIEW_CHANGES": "View unpublished changes",
        "DRAFT": "Osnutek",
        "ARCHIVE": "Arhiv",
        "BACK_TO_ARTICLES": "Nazaj na članke"
      },
      "PENDING_CHANGES_POPOVER": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "This article has draft changes that aren't live yet. Apply them before changing the status, or discard them?",
        "APPLY": "Apply changes",
        "DISCARD": "Discard changes"
      },
      "DIFF_DIALOG": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "Compare your draft against the version that's currently live.",
        "TITLE_LABEL": "Title"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Več lastnosti",
        "UNCATEGORIZED": "Nekategorizirano",
        "EDITOR_PLACEHOLDER": "Napišite nekaj..."
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Lastnosti članka",
        "META_DESCRIPTION": "Meta opis",
        "META_DESCRIPTION_PLACEHOLDER": "Dodajte meta opis",
        "META_TITLE": "Meta naslov",
        "META_TITLE_PLACEHOLDER": "Dodajte meta naslov",
        "META_TAGS": "Meta oznake",
        "META_TAGS_PLACEHOLDER": "Dodaj meta oznake"
      },
      "API": {
        "ERROR": "Napaka pri shranjevanju članka"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Nov portal",
      "PORTALS": "Portali",
      "CREATE_PORTAL": "Ustvarite in upravljajte več portalov",
      "ARTICLES": "članki",
      "DOMAIN": "domena",
      "PORTAL_NAME": "Ime portala"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Ustvari nov portal",
      "DESCRIPTION": "Dajte portalu ime in ustvarite uporabniku prijazen URL. Oba lahko kasneje spremenite v nastavitvah.",
      "CONFIRM_BUTTON_LABEL": "Ustvari",
      "NAME": {
        "LABEL": "Ime",
        "PLACEHOLDER": "Uporabniški vodič | Chatwoot",
        "MESSAGE": "Izberite ime za vaš portal.",
        "ERROR": "Ime je obvezno"
      },
      "SLUG": {
        "LABEL": "Oznaka",
        "PLACEHOLDER": "portal",
        "ERROR": "Slug je obvezen",
        "FORMAT_ERROR": "Vnesite veljavno oznako, na primer: portal"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logotip",
          "IMAGE_UPLOAD_ERROR": "Slike ni bilo mogoče naložiti! Poskusite znova",
          "IMAGE_UPLOAD_SUCCESS": "Slika je bila uspešno dodana. Za shranjevanje logotipa kliknite Shrani spremembe",
          "IMAGE_DELETE_SUCCESS": "Logotip je bil uspešno izbrisan",
          "IMAGE_DELETE_ERROR": "Brisanje logotipa ni bilo mogoče",
          "IMAGE_UPLOAD_SIZE_ERROR": "Velikost slike mora biti manjša od {size}MB"
        },
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Ime portala",
          "ERROR": "Ime je obvezno"
        },
        "HEADER_TEXT": {
          "LABEL": "Besedilo glave",
          "PLACEHOLDER": "Besedilo glave portala"
        },
        "PAGE_TITLE": {
          "LABEL": "Naslov strani",
          "PLACEHOLDER": "Naslov strani portala"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Povezava na domačo stran",
          "PLACEHOLDER": "Povezava do domače strani portala",
          "ERROR": "Vnesite veljaven URL. Povezava na domačo stran se mora začeti z 'http://' ali 'https://'."
        },
        "SLUG": {
          "LABEL": "Oznaka",
          "PLACEHOLDER": "Slug portala"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Pripomoček za klepet v živo",
          "PLACEHOLDER": "Izberite pripomoček za klepet v živo",
          "HELP_TEXT": "Izberite pripomoček za klepet v živo, ki se bo prikazal v vašem centru za pomoč",
          "NONE_OPTION": "Brez pripomočka"
        },
        "BRAND_COLOR": {
          "LABEL": "Barva blagovne znamke"
        },
        "SAVE_CHANGES": "Shrani spremembe"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Lastna domena",
          "LABEL": "Lastna domena:",
          "DESCRIPTION": "Portal lahko gostite na lastni domeni. Če želite, da je dostopen na ločeni domeni svoje spletne strani, to domeno vnesite v to polje.",
          "STATUS_DESCRIPTION": "Vaš prilagojeni portal bo začel delovati takoj, ko bo potrjen.",
          "PLACEHOLDER": "Lastna domena portala",
          "EDIT_BUTTON": "Uredi",
          "ADD_BUTTON": "Dodaj lastno domeno",
          "STATUS": {
            "LIVE": "Aktivno",
            "PENDING": "Čakanje na potrditev",
            "ERROR": "Potrditev ni uspela"
          },
          "DIALOG": {
            "ADD_HEADER": "Dodaj lastno domeno",
            "EDIT_HEADER": "Uredi lastno domeno",
            "ADD_CONFIRM_BUTTON_LABEL": "Dodaj domeno",
            "EDIT_CONFIRM_BUTTON_LABEL": "Posodobi domeno",
            "LABEL": "Lastna domena",
            "PLACEHOLDER": "Lastna domena portala",
            "ERROR": "Lastna domena je obvezna",
            "FORMAT_ERROR": "Vnesite veljaven URL domene, na primer naslov za pomoč"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS konfiguracija",
            "DESCRIPTION": "Prijavite se v račun pri ponudniku DNS in dodajte zapis CNAME za domeno, ki kaže na naš naslov za pomoč",
            "COPY": "CNAME je bil uspešno kopiran",
            "SEND_INSTRUCTIONS": {
              "HEADER": "Pošlji navodila",
              "DESCRIPTION": "Če želite, da ta korak opravi nekdo iz vaše razvojne ekipe, lahko spodaj vnesete njegov e-poštni naslov, mi pa mu bomo poslali potrebna navodila.",
              "PLACEHOLDER": "Vnesite njihov e-poštni naslov",
              "ERROR": "Vnesite veljaven e-poštni naslov",
              "SEND_BUTTON": "Pošlji"
            }
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Izbriši {portalName}",
          "HEADER": "Izbriši portal",
          "DESCRIPTION": "Trajno izbrišite ta portal. Tega dejanja ni mogoče razveljaviti",
          "DIALOG": {
            "HEADER": "Ste prepričani, da želite izbrisati {portalName}?",
            "DESCRIPTION": "To je trajna akcija, ki je ni mogoče razveljaviti.",
            "CONFIRM_BUTTON_LABEL": "Izbriši"
          }
        },
        "EDIT_CONFIGURATION": "Uredi konfiguracijo"
      },
      "LAYOUT_CONTENT": {
        "HEADER": "Appearance",
        "DESCRIPTION": "Pick the layout that fits how your visitors read.",
        "LAYOUT": {
          "CLASSIC": {
            "TITLE": "Classic",
            "DESCRIPTION": "A welcoming home page with search and featured topics."
          },
          "SIDEBAR": {
            "TITLE": "Documentation",
            "DESCRIPTION": "Side-by-side navigation that keeps every guide a click away."
          }
        },
        "SOCIAL_LINKS": {
          "HEADER": "Social links",
          "DESCRIPTION": "Add the handle for each network and your help center builds the full link. Shown in the documentation layout footer.",
          "PLACEHOLDER": "handle",
          "ADD": "Add social link",
          "REMOVE": "Odstrani"
        },
        "SAVE": "Shrani spremembe"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal je bil uspešno ustvarjen",
          "ERROR_MESSAGE": "Ni mogoče ustvariti portala"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal je bil uspešno posodobljen",
          "ERROR_MESSAGE": "Ni mogoče posodobiti portala"
        }
      }
    },
    "PDF_UPLOAD": {
      "TITLE": "Naloži PDF dokument",
      "DESCRIPTION": "Naložite PDF dokument za samodejno ustvarjanje pogostih vprašanj z uporabo AI",
      "DRAG_DROP_TEXT": "Povlecite in spustite svojo PDF datoteko sem ali kliknite za izbiro",
      "SELECT_FILE": "Izberite PDF datoteko",
      "ADDITIONAL_CONTEXT_LABEL": "Dodatni kontekst (neobvezno)",
      "ADDITIONAL_CONTEXT_PLACEHOLDER": "Dodajte dodaten kontekst ali navodila za ustvarjanje pogostih vprašanj...",
      "UPLOADING": "Nalaganje...",
      "UPLOAD": "Naloži in obdela",
      "CANCEL": "Prekliči",
      "ERROR_INVALID_TYPE": "Izberite veljavno PDF datoteko",
      "ERROR_FILE_TOO_LARGE": "Velikost datoteke mora biti manjša od 512MB",
      "ERROR_UPLOAD_FAILED": "Nalaganje PDF ni uspelo. Poskusite znova."
    },
    "PDF_DOCUMENTS": {
      "TITLE": "PDF dokumenti",
      "DESCRIPTION": "Upravljajte naložene PDF dokumente in iz njih ustvarjajte pogosta vprašanja",
      "UPLOAD_PDF": "Naloži PDF",
      "UPLOAD_FIRST_PDF": "Naložite svoj prvi PDF",
      "UPLOADED_BY": "Naložil",
      "GENERATE_FAQS": "Ustvari pogosta vprašanja",
      "GENERATING": "Ustvarjam...",
      "CONFIRM_DELETE": "Ste prepričani, da želite izbrisati {filename}?",
      "EMPTY_STATE": {
        "TITLE": "Še ni PDF dokumentov",
        "DESCRIPTION": "Naložite PDF dokumente za samodejno ustvarjanje pogostih vprašanj z uporabo umetne inteligence"
      },
      "STATUS": {
        "UPLOADED": "Pripravljeno",
        "PROCESSING": "Obdelava",
        "PROCESSED": "Dokončano",
        "FAILED": "Neuspešno"
      }
    },
    "CONTENT_GENERATION": {
      "TITLE": "Ustvarjanje vsebine",
      "DESCRIPTION": "Naložite PDF dokumente za samodejno ustvarjanje vsebine pogostih vprašanj z uporabo umetne inteligence",
      "UPLOAD_TITLE": "Naloži PDF dokument",
      "DRAG_DROP": "Povlecite in spustite svoj PDF tukaj ali kliknite za izbiro",
      "SELECT_FILE": "Izberite PDF datoteko",
      "UPLOADING": "Obdelava dokumenta...",
      "UPLOAD_SUCCESS": "Dokument je bil uspešno obdelan!",
      "UPLOAD_ERROR": "Nalaganje dokumenta ni uspelo. Poskusite znova.",
      "INVALID_FILE_TYPE": "Izberite veljavno PDF datoteko",
      "FILE_TOO_LARGE": "Velikost datoteke mora biti manjša od 512MB",
      "GENERATED_CONTENT": "Ustvarjena vsebina pogostih vprašanj",
      "PUBLISH_SELECTED": "Objavi izbrano",
      "PUBLISHING": "Objavljanje...",
      "FROM_DOCUMENT": "Iz dokumenta",
      "NO_CONTENT": "Ni na voljo ustvarjene vsebine. Naložite PDF dokument za začetek.",
      "LOADING": "Nalaganje ustvarjene vsebine..."
    }
  }
}
